<div
  *ngIf="visible"
  class="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2 tw-px-4 sm:tw-px-6 tw-py-2.5 tw-bg-[#0D1E19] tw-border-0 tw-border-b tw-border-solid tw-border-gray-700">
  <span
    class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-[#7FFFD4] tw-shrink-0 tw-shadow-[0_0_8px_1px_rgba(127,255,212,0.6)]"
    aria-hidden="true"></span>
  <p class="tw-flex-1 tw-basis-60 tw-m-0 tw-text-sm tw-leading-snug tw-text-gray-300">
    <span class="tw-font-semibold tw-text-white">We're moving to gotlivedata.com soon.</span>
    Your chats, saved lists and searches move with you. Nothing here breaks until then.
  </p>
  <div class="tw-flex tw-items-center tw-gap-4 sm:tw-gap-5 tw-ml-auto">
    <button
      type="button"
      (click)="takeMeThere()"
      class="tw-inline-flex tw-items-center tw-gap-2 tw-bg-[#7FFFD4] hover:tw-bg-[#A9FFE3] tw-text-[#0C2A21] tw-text-sm tw-font-semibold tw-px-4 tw-py-2 tw-rounded-lg tw-whitespace-nowrap tw-transition-colors">
      Take me there
      <span aria-hidden="true">→</span>
    </button>
    <button
      type="button"
      (click)="remindLater()"
      class="tw-p-0 tw-text-sm tw-text-gray-300 hover:tw-text-white tw-underline tw-underline-offset-4 tw-whitespace-nowrap">
      Remind me later
    </button>
  </div>
</div>
